import { Dialog, TabsNavigationItemData } from "client/Components";
import { PropsWithChildren, ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { AppStoreViewKind } from "./AppStoreDialog";

export type RootViewProps = {
	onClose: () => void;
	onChangeView(view: AppStoreViewKind): void;
	tabs: readonly TabsNavigationItemData<AppStoreViewKind>[];
	activeTab: AppStoreViewKind;
};

export const RootView = (props: PropsWithChildren<RootViewProps>): ReactElement => {
	const {
		activeTab,
		tabs,
		onChangeView,
		onClose,
		children
	} = props;

	return (
		<>
			<Dialog.Header
				hasBorder
				title={localize("_AppStore")}
				onClose={onClose}
				tabs={tabs}
				onTabClick={onChangeView}
				activeTab={activeTab}
			/>
			{children}
		</>
	);
};
RootView.displayName = "RootView";